"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var axios_1 = __importDefault(require("axios"));
var queryString = __importStar(require("querystring"));
var AxiosLogger = /** @class */ (function () {
    /**
     * @constructor
     * @param args.baseURL Main request base URL
     */
    function AxiosLogger(args) {
        if (!args) {
            return;
        }
        var _a = args.baseURL, baseURL = _a === void 0 ? '' : _a, _b = args.isServer, isServer = _b === void 0 ? typeof window === 'undefined' || typeof document === 'undefined' : _b, _c = args.request, request = _c === void 0 ? false : _c, _d = args.response, response = _d === void 0 ? false : _d, _e = args.quiet, quiet = _e === void 0 ? false : _e;
        this.baseURL = baseURL;
        this.isServer = isServer;
        this.showRequest = request;
        this.showResponse = response;
        this.quiet = quiet;
        this.log = this.log.bind(this);
    }
    Object.defineProperty(AxiosLogger.prototype, "response", {
        get: function () {
            return [this.log, this.log];
        },
        enumerable: false,
        configurable: true
    });
    AxiosLogger.prototype.log = function (response) {
        if (this.quiet) {
            return this.wrapRejectIfNeeded(response);
        }
        // When the request is canceled
        if (axios_1.default.isCancel(response)) {
            this.printCancelLog(response.message);
            return this.wrapRejectIfNeeded(response);
        }
        if (!('config' in response)) {
            return this.wrapRejectIfNeeded(response);
        }
        var config = response.config;
        var method = config.method, url = config.url, params = config.params, data = config.data;
        var query = ("" + url).split('?')[1];
        var search = query && queryString.parse(query);
        // When receive normal response
        if ('status' in response) {
            var responseData = response.data, status_1 = response.status;
            this.printResponseLog(method, url, status_1, { search: search, params: params, data: data }, responseData);
            return this.wrapRejectIfNeeded(response);
        }
        // When receive error response
        var status = response.response ? response.response.status : response.code;
        this.printResponseLog(method, url, status, { search: search, params: params, data: data }, response.response);
        return this.wrapRejectIfNeeded(response);
    };
    /**
     * Print a log of response
     * @param [method] Request method
     * @param [url] Request url
     * @param [status] HTTP status
     * @param [request] Request data
     * @param [response] Response data
     */
    AxiosLogger.prototype.printResponseLog = function (method, url, status, requests, response) {
        if (method === void 0) { method = 'unknown'; }
        if (url === void 0) { url = 'unknown'; }
        if (status === void 0) { status = 'unknown'; }
        // Ignore queries
        var path = this.optimizePath(url);
        var isSuccess = status < 400;
        var parseRequest = function (request) {
            // Clone the request if it is object
            if (typeof request === 'object') {
                try {
                    return JSON.parse(JSON.stringify(request));
                }
                catch (_a) {
                    // Do nothing
                }
            }
            try {
                return JSON.parse(request);
            }
            catch (_b) {
                return request;
            }
        };
        var search = parseRequest(requests === null || requests === void 0 ? void 0 : requests.search);
        var params = parseRequest(requests === null || requests === void 0 ? void 0 : requests.params);
        var data = parseRequest(requests === null || requests === void 0 ? void 0 : requests.data);
        // Clone the request if it is object
        if (typeof response === 'object') {
            try {
                response = JSON.parse(JSON.stringify(response));
            }
            catch (e) {
                // Do nothing
            }
        }
        if (this.isServer) {
            var style_1 = isSuccess
                ? '\x1b[42m \x1b[0m \x1b[32m%s\x1b[0m'
                : '\x1b[41m \x1b[0m \x1b[31m%s\x1b[0m';
            var titleStyle = isSuccess
                ? '\x1b[42m \x1b[0m %s'
                : '\x1b[41m \x1b[0m %s';
            console.log(style_1, method + ": " + url + " - " + status);
            if (this.showRequest) {
                if (search != null) {
                    console.log(titleStyle, 'search');
                    console.log(search);
                }
                if (params != null) {
                    console.log(titleStyle, 'params');
                    console.log(params);
                }
                if (data != null) {
                    console.log(titleStyle, 'body');
                    console.log(data);
                }
            }
            if (this.showResponse) {
                console.log(titleStyle, 'response');
                if (isSuccess) {
                    console.log(response);
                }
                else {
                    console.log(response);
                }
            }
            return;
        }
        var style = isSuccess
            ? 'background: #eee; border-left: 10px solid #2CA58D; color: #2D4E19; padding: 2px 10px'
            : 'background: #eee; border-left: 10px solid #A53860; color: #69140E; padding: 2px 10px';
        console.groupCollapsed("%c" + method + ": " + path + " - " + status, style);
        if (search != null) {
            console.log('search :', search);
        }
        if (params != null) {
            console.log('params :', params);
        }
        if (data != null) {
            console.log(' data  :', data);
        }
        console.log('%cresponse\n', 'padding-bottom: 0.5em; font-weight: bold', response);
        console.groupEnd();
    };
    /**
     * Print request canceled log
     */
    AxiosLogger.prototype.printCancelLog = function (message) {
        if (message === void 0) { message = '(no message)'; }
        if (this.isServer) {
            console.log('\x1b[43m \x1b[0m \x1b[33m%s\x1b[0m', "Canceled - " + message);
        }
        else {
            console.log("%ccanceled - " + message, 'background: #eee; border-left: 10px solid #FFA552; color: #8C5A2D; padding: 2px 10px; font-weight: bold');
        }
    };
    AxiosLogger.prototype.wrapRejectIfNeeded = function (response) {
        var isAxiosError = 'isAxiosError' in response && response.isAxiosError;
        return isAxiosError ? Promise.reject(response) : response;
    };
    /**
     * Optimize displaying path
     */
    AxiosLogger.prototype.optimizePath = function (url) {
        var path = url.replace(/^([^?]*).*/, '$1');
        if (!this.baseURL) {
            return path;
        }
        if (!Array.isArray(this.baseURL)) {
            return path.replace(this.baseURL, '');
        }
        for (var i = 0; i < path.length; i++) {
            var basePath = this.baseURL[i];
            if (!path.startsWith(basePath)) {
                continue;
            }
            return path.replace(basePath, '');
        }
        return path;
    };
    return AxiosLogger;
}());
module.exports = AxiosLogger;
